module.exports = __webpack_public_path__ + "img/icon-painter.96711b24.png";